import type { Maybe, Skill } from '@seek/ca-myprofile-utils';
import { SkillsForm } from '@seek/profile-edit-ui';

import type { DirtyFormProps } from 'src/components/FormDrawer/FormDrawer';
import { SKILLS } from 'src/components/Router';
import { useEnterReadMode } from 'src/components/Router/useEnterReadMode';
import { useFocus } from 'src/modules/hooks/useFocus';

import { useSkills, useSuggestedSkills, useUpdateSkills } from '../data';

export const EditSkills = ({ onFormDirtyChange }: DirtyFormProps) => {
  const { skills, loading } = useSkills();
  const { suggestedSkills } = useSuggestedSkills();

  const enterReadMode = useEnterReadMode();
  const [updateSkills] = useUpdateSkills();

  const onSubmit = ({
    values,
    suggestedSkillsAdded,
  }: {
    values: Skill[];
    suggestedSkillsAdded: Maybe<number>;
  }) => {
    const skillsHaveNotBeenUpdated =
      skills.length === values.length &&
      [...skills].reverse().every((skill, index) => skill === values[index]);

    if (skillsHaveNotBeenUpdated === false) {
      updateSkills(
        { skillsData: { skills: values } },
        { suggestedSkillsAdded },
      );
    }

    enterReadMode();
  };

  const skillsRef = useFocus<HTMLInputElement>({
    card: SKILLS,
    fieldName: 'skills',
  });

  if (loading) {
    return null;
  }

  return (
    <SkillsForm
      initialSkills={skills}
      initialSuggestedSkills={suggestedSkills}
      onSubmit={onSubmit}
      onCancel={enterReadMode}
      inputRef={skillsRef}
      onFormDirtyChange={onFormDirtyChange}
    />
  );
};
